import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchAllSchemeMasters,
  fetchOneSchemeMaster,
  createSchemeMaster,
  updateSchemeMaster,
  deleteSchemeMaster,
  generateSchemeEligibilitySummary,
  generateSchemeEligibilityDetail,
  generateSchemePrint,
  generateSchemePendingOrders,
} from "../../services/schememaster";

export const useAllSchemeMasters = (filter) => {
  return useQuery({
    queryKey: ["schemeMasters", filter],
    queryFn: () => fetchAllSchemeMasters(filter),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useOneSchemeMaster = (id) => {
  return useQuery({
    queryKey: ["schemeMaster", id],
    queryFn: () => fetchOneSchemeMaster(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateSchemeMaster = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createSchemeMaster(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schemeMasters"] });
    },
  });
};

export const useUpdateSchemeMaster = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateSchemeMaster(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["schemeMasters"] });
      queryClient.invalidateQueries({ queryKey: ["schemeMaster", variables.id] });
    },
  });
};

export const useDeleteSchemeMaster = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteSchemeMaster(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["schemeMasters"] });
      queryClient.invalidateQueries({ queryKey: ["schemeMaster", id] });
    },
  });
};

export const useGenerateSchemeEligibilitySummary = () => {
  return useMutation({
    mutationFn: (data) => generateSchemeEligibilitySummary(data),
  });
};

export const useGenerateSchemeEligibilityDetail = () => {
  return useMutation({
    mutationFn: (data) => generateSchemeEligibilityDetail(data),
  });
};

export const useGenerateSchemePrint = () => {
  return useMutation({
    mutationFn: (data) => generateSchemePrint(data),
  });
};

export const useGenerateSchemePendingOrders = () => {
  return useMutation({
    mutationFn: (data) => generateSchemePendingOrders(data),
  });
};
